import React, { useState, useEffect } from 'react';
import AlertNotification, { AlertColor } from '../../../../components/Dialog/AlertNotification';
import LcLoading from '../../../../components/Generic/LcLoading';
import { PPFormHH, PPFormTemplate } from '../../../../components/Layout/PPFormHH/PPFormHH';
import ServiceService from '../../../../services/ServiceService/ServiceService';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';

interface Props {
    solicitation: any,
    visible?: boolean
}

const SolicitationDynamicForm: React.FC<Props> = (props) => {
    const serviceService = new ServiceService(props);
    const solicitationService = new SolicitationService(props);
    const [templatePPForm, setTemplatePPForm] = useState<PPFormTemplate>();
    const [loading, setLoading] = useState<boolean>(false);
    const [resultDataResult, setResultDataResult] = useState<any>();
    const [refreshSeed, setRefreshSeed] = useState<number>();
    const [error, setError] = useState<any>();
    const [show, setShow] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);

    useEffect(() => {
        setTemplatePPForm(undefined);
        setShow(false);
        setResultDataResult([]);
        setLoading(false);
        setOpenNotificacao(false);
        setMessage("");

        if (props.solicitation) {
            buildExtraForm();
        }
    }, [props.solicitation]);

    const getWindowSize = () => {
        const { innerHeight } = window;
        return innerHeight;
    }

    const [windowHeight, setWindowHeight] = useState<number>(getWindowSize());

    useEffect(() => {
        function handleWindowResize() {
            setWindowHeight(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const buildExtraForm = async () => {
        setLoading(true);

        const itemTemp = props.solicitation;

        try {
            var response = await serviceService.getForm(props.solicitation.idProcess, false, false, props.solicitation.idService, props.solicitation.id);
            var solicitationResponse = await solicitationService.GetDynamicFormData(props.solicitation.id);

            if (itemTemp === props.solicitation) {
                setResultDataResult(solicitationResponse.data);
                if (response.data !== '') setShow(true);

                setTemplatePPForm(response.data);
            }
        }
        catch (e) {
            debugger;
        }

        setLoading(false);
    }

    const handleResultData = (data: any) => {
        setResultDataResult(data);
    }

    const formStyle = {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
    } as React.CSSProperties;

    const containerStyle = {
        flexWrap: "wrap",
        maxHeight: templatePPForm && templatePPForm.fields.length > 25 ? '1600px' : templatePPForm && templatePPForm.fields.length > 15 ? '1000px' : '600px'
    } as React.CSSProperties;

    const notificationValidation = (mensagem: string, type: AlertColor) => {
        setMessage(mensagem);
        setSeverity(type);
        setOpenNotificacao(true);
    };

    const handleSubmit = async () => {
        setOpenNotificacao(false);

        setLoading(true);

        var block = false;

        templatePPForm && templatePPForm.fields
            && templatePPForm.fields.map((item) => {
                try {
                    if (!(resultDataResult && resultDataResult[item.name])) {
                        item.required && notificationValidation(`${item.required.required}`, "warning");
                        if (item.required) block = true;
                    }
                }
                catch (e) {
                    debugger;
                }
            });

        if (block) {
            setLoading(false);
            return;
        }

        try {
            await solicitationService.saveDynamicFormSolicitation({ IdSolicitation: props.solicitation.id, Responses: resultDataResult });
        }
        catch (error) {
            debugger;
        }

        setLoading(false);
    }

    return (
        <div className='divOrderDynamicForm'>
            <LcLoading loading={loading} label="Carregando...">
                {
                    show && templatePPForm &&
                    <>
                        <span style={{ fontWeight: "600" }}>{templatePPForm && templatePPForm.title ? templatePPForm.title : ''}</span>
                        <div style={{ marginTop: "10px" }} />
                        <PPFormHH
                            header={''}
                            EditForm={false}
                            data={resultDataResult}
                            template={templatePPForm}
                            detailButton={false}
                            visible={props.visible}
                            enableNotifications={true}
                            refreshSeed={refreshSeed}
                            setResultData={(data) => handleResultData(data)}
                            setError={(error) => { setError(error); }}
                            maxWidth={"28rem"}
                            maxWidthInternal={"27rem"}
                            direction={"row"}
                            formStyle={formStyle}
                            containerStyle={containerStyle}
                        />
                        <button className={"lc-button bg-info"} style={{ margin: '30px 0px' }} onClick={() => handleSubmit()}>Salvar</button>
                    </>
                }
            </LcLoading>

            <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />
        </div>
    );
};

export default SolicitationDynamicForm;